import { HTTPClient, propsToDate } from '@abaco/web-common/src/HTTP';
import { BooteStatistics, SensorDataItem, WellObject } from '../models/SensorDataModel';

export default class SensorDataApi {
    private http: HTTPClient;
    private path: string;

    constructor(http: HTTPClient, path: string) {
        this.http = http;
        this.path = path;
    }

    public async getSensorDataItems(pkCuaa: number, stationId: string, sensorId: string, fromParameter?: Date, toParameter?: Date): Promise<SensorDataItem[]> {
        const from = fromParameter?.toISOString() || "";
        const to = toParameter?.toISOString() || "";
        const res = await this.http.get(`/${this.path}/v1/farm/${pkCuaa}/stations/${stationId}/sensors/${sensorId}/data`, { params: { from, to } })

        res.data.results.forEach((el: SensorDataItem) => propsToDate(el, ['when']))
        return res.data.results as unknown as SensorDataItem[];
    }


    public async getAllWells(): Promise<WellObject[]> {
        const res = await this.http.get(`/siticatasto/dbgis-servlet/tl_data/`, { params: { svccode: "portal/get_all_well" } })

        return res.data.services[0].entities;
    }

    public async getCouncil(lonLat: number[]): Promise<string | null>{
        const url = `/sitiagri-rest-api/api_basic/v1/plots/dictionary_councils`;
        const params = {
            lat: lonLat[1],
            long: lonLat[0]
        }
        const res = await this.http.get(url, {params});

        return res.data.records && res.data.records.length > 0 ? res.data.records[0].council_label : null;

    }

    public async getBooteStatistics(pkcuaa: number, booteId: string, from: Date, to: Date): Promise<BooteStatistics>{
        const url = `/iot/api/v1/farm/${pkcuaa}/accounts/boote/statistics`;
        const params ={
            animal: booteId,
            from, 
            to
        }
        const res = await this.http.get<BooteStatistics>(url, {params});
        propsToDate(res.data, ["whenEniDistanceWasMin","whenMeteoDistanceWasMin", "whenWaterDistanceWasMin"])
        return res.data;
    }

    // private mockData = [
    //     {
    //         "when": "2021-02-04T15:16:00Z",
    //         "value": {
    //             "lat": 40.38520728,
    //             "lon": 15.96684119
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T15:17:00Z",
    //         "value": {
    //             "lat": 40.37770728,
    //             "lon": 15.97064119
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T15:50:00Z",
    //         "value": {
    //             "lat": 40.46751,
    //             "lon": 15.831594
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T15:51:00Z",
    //         "value": {
    //             "lat": 40.42916,
    //             "lon": 15.899948
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T15:52:00Z",
    //         "value": {
    //             "lat": 40.46031,
    //             "lon": 15.913412
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T15:53:00Z",
    //         "value": {
    //             "lat": 40.433901,
    //             "lon": 15.883064
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T15:54:00Z",
    //         "value": {
    //             "lat": 40.422128,
    //             "lon": 15.889434
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T15:55:00Z",
    //         "value": {
    //             "lat": 40.432706,
    //             "lon": 15.90285
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T15:58:00Z",
    //         "value": {
    //             "lat": 40.395815,
    //             "lon": 15.806014
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:19:00Z",
    //         "value": {
    //             "lat": 40.476978,
    //             "lon": 15.832766
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:20:00Z",
    //         "value": {
    //             "lat": 40.37890728,
    //             "lon": 15.98214119
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:26:00Z",
    //         "value": {
    //             "lat": 40.39187,
    //             "lon": 15.83118
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:50:00Z",
    //         "value": {
    //             "lat": 40.466066,
    //             "lon": 15.80664
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:51:00Z",
    //         "value": {
    //             "lat": 40.45826,
    //             "lon": 15.906448
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:52:00Z",
    //         "value": {
    //             "lat": 40.363748,
    //             "lon": 15.93823
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:53:00Z",
    //         "value": {
    //             "lat": 40.37920728,
    //             "lon": 15.96184119
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:54:00Z",
    //         "value": {
    //             "lat": 40.380748,
    //             "lon": 15.95623
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:56:00Z",
    //         "value": {
    //             "lat": 40.45036,
    //             "lon": 15.90632
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:57:00Z",
    //         "value": {
    //             "lat": 40.467066,
    //             "lon": 15.80164
    //         }
    //     },
    //     {
    //         "when": "2021-02-04T20:58:00Z",
    //         "value": {
    //             "lat": 40.437501,
    //             "lon": 15.898764
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:17:00Z",
    //         "value": {
    //             "lat": 40.37370728,
    //             "lon": 15.97464119
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:19:00Z",
    //         "value": {
    //             "lat": 40.474555,
    //             "lon": 15.819494
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:50:00Z",
    //         "value": {
    //             "lat": 40.42406,
    //             "lon": 15.901348
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:52:00Z",
    //         "value": {
    //             "lat": 40.383686,
    //             "lon": 15.947356
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:53:00Z",
    //         "value": {
    //             "lat": 40.449828,
    //             "lon": 15.796644
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:54:00Z",
    //         "value": {
    //             "lat": 40.471403,
    //             "lon": 15.898988
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:55:00Z",
    //         "value": {
    //             "lat": 40.450201,
    //             "lon": 15.898364
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:56:00Z",
    //         "value": {
    //             "lat": 40.40467,
    //             "lon": 15.82358
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:57:00Z",
    //         "value": {
    //             "lat": 40.40820728,
    //             "lon": 15.96424119
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:58:00Z",
    //         "value": {
    //             "lat": 40.38567,
    //             "lon": 15.81658
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T08:59:00Z",
    //         "value": {
    //             "lat": 40.449666,
    //             "lon": 15.76984
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:16:00Z",
    //         "value": {
    //             "lat": 40.471566,
    //             "lon": 15.80124
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:17:00Z",
    //         "value": {
    //             "lat": 40.40680728,
    //             "lon": 15.98214119
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:18:00Z",
    //         "value": {
    //             "lat": 40.39080728,
    //             "lon": 15.95344119
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:51:00Z",
    //         "value": {
    //             "lat": 40.468555,
    //             "lon": 15.817494
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:52:00Z",
    //         "value": {
    //             "lat": 40.444128,
    //             "lon": 15.868834
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:53:00Z",
    //         "value": {
    //             "lat": 40.45121,
    //             "lon": 15.924466
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:54:00Z",
    //         "value": {
    //             "lat": 40.350486,
    //             "lon": 15.940256
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:55:00Z",
    //         "value": {
    //             "lat": 40.442233,
    //             "lon": 15.915368
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:57:00Z",
    //         "value": {
    //             "lat": 40.38287,
    //             "lon": 15.85878
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:58:00Z",
    //         "value": {
    //             "lat": 40.437901,
    //             "lon": 15.894264
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T15:59:00Z",
    //         "value": {
    //             "lat": 40.37487,
    //             "lon": 15.85178
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T20:16:00Z",
    //         "value": {
    //             "lat": 40.474731,
    //             "lon": 15.817828
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T20:17:00Z",
    //         "value": {
    //             "lat": 40.473766,
    //             "lon": 15.79804
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T20:20:00Z",
    //         "value": {
    //             "lat": 40.36140728,
    //             "lon": 15.94174119
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T20:50:00Z",
    //         "value": {
    //             "lat": 40.385686,
    //             "lon": 15.942956
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T20:51:00Z",
    //         "value": {
    //             "lat": 40.437928,
    //             "lon": 15.866634
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T20:52:00Z",
    //         "value": {
    //             "lat": 40.368748,
    //             "lon": 15.95323
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T20:53:00Z",
    //         "value": {
    //             "lat": 40.390171,
    //             "lon": 15.970124
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T20:55:00Z",
    //         "value": {
    //             "lat": 40.39467,
    //             "lon": 15.83208
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T20:56:00Z",
    //         "value": {
    //             "lat": 40.41267,
    //             "lon": 15.84308
    //         }
    //     },
    //     {
    //         "when": "2021-02-05T20:57:00Z",
    //         "value": {
    //             "lat": 40.442468,
    //             "lon": 15.907652
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:16:00Z",
    //         "value": {
    //             "lat": 40.480773,
    //             "lon": 15.824754
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:17:00Z",
    //         "value": {
    //             "lat": 40.40120728,
    //             "lon": 15.96024119
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:18:00Z",
    //         "value": {
    //             "lat": 40.484766,
    //             "lon": 15.81444
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:19:00Z",
    //         "value": {
    //             "lat": 40.37520728,
    //             "lon": 15.96104119
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:51:00Z",
    //         "value": {
    //             "lat": 40.407386,
    //             "lon": 15.958356
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:52:00Z",
    //         "value": {
    //             "lat": 40.38867,
    //             "lon": 15.80798
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:53:00Z",
    //         "value": {
    //             "lat": 40.361861,
    //             "lon": 15.959738
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:54:00Z",
    //         "value": {
    //             "lat": 40.457901,
    //             "lon": 15.909664
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:55:00Z",
    //         "value": {
    //             "lat": 40.429728,
    //             "lon": 15.888234
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:56:00Z",
    //         "value": {
    //             "lat": 40.436156,
    //             "lon": 15.909338
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:57:00Z",
    //         "value": {
    //             "lat": 40.458901,
    //             "lon": 15.899664
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:58:00Z",
    //         "value": {
    //             "lat": 40.398386,
    //             "lon": 15.948356
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T08:59:00Z",
    //         "value": {
    //             "lat": 40.442973,
    //             "lon": 15.902062
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T15:19:00Z",
    //         "value": {
    //             "lat": 40.36320728,
    //             "lon": 15.95394119
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T15:20:00Z",
    //         "value": {
    //             "lat": 40.37490728,
    //             "lon": 15.95564119
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T15:50:00Z",
    //         "value": {
    //             "lat": 40.463756,
    //             "lon": 15.904938
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T15:51:00Z",
    //         "value": {
    //             "lat": 40.458273,
    //             "lon": 15.901664
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T15:52:00Z",
    //         "value": {
    //             "lat": 40.376861,
    //             "lon": 15.955738
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T15:53:00Z",
    //         "value": {
    //             "lat": 40.415628,
    //             "lon": 15.877334
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T15:54:00Z",
    //         "value": {
    //             "lat": 40.43891,
    //             "lon": 15.91744
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T15:55:00Z",
    //         "value": {
    //             "lat": 40.422701,
    //             "lon": 15.887464
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T15:56:00Z",
    //         "value": {
    //             "lat": 40.39277,
    //             "lon": 15.83148
    //         }
    //     },
    //     {
    //         "when": "2021-02-06T15:57:00Z",
    //         "value": {
    //             "lat": 40.39177,
    //             "lon": 15.82348
    //         }
    //     }
    // ]
}




/**
 * Use to mock data Ticket #53370
 */


// const mockData2 = [
//     {
//         "when": "2021-06-30T13:31:28Z",
//         "value": {lat: 44.086389, lon: 11.460833}
//     },
//     {
//         "when": "2021-06-28T14:01:29Z",
//         "value": {lat: 44.434475, lon: 15.895424}
//     },
//     {
//         "when": "2021-06-27T14:31:29Z",
//         "value": {lat: 44.434475, lon: 11.895424}
//     },
//     {
//         "when": "2021-06-15T15:01:28Z",
//         "value": {lat: 44.435475, lon: 11.896424}
//     },
//     {
//         "when": "2021-06-16T15:31:28Z",
//         "value": {lat: 44.434465, lon: 11.892424}
//     },
//     {
//         "when": "2021-06-23T16:01:28Z",
//         "value": {lat: 44.434575, lon: 11.895324}
//     }
// ]

// let countingMock = 0;
// export default class SensorDataApi {
//     private http: HTTPClient;
//     private path: string;

//     constructor(http: HTTPClient, path: string) {
//         this.http = http;
//         this.path = path;
//     }

//     public async getSensorDataItems(pkCuaa: number, stationId: string, sensorId: string, fromParameter: string, toParameter: string): Promise<SensorDataItem[]> {
//         // const fromParameter ='2020-06-18T00:00:00Z';
//         // const toParameter ='2020-10-18T00:00:00Z';
//         const res = await this.http.get(
//             `/${this.path}/v1/farm/${pkCuaa}/stations/${stationId}/sensors/${sensorId}/data`, {params: {from: fromParameter, to: toParameter}})

//         if (res.data.results.length == 0 && sensorId == "position") {
//             res.data.results = countingMock % 2 == 0 ? mockData : mockData2;
//             countingMock++;
//         }
//         propsToDate(res.data.results, ['when'])
//         return res.data.results;
//     }
// }
